import { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const urlB64ToUint8 = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export function ClientPushButton({ email = "", orderCode = "" }) {
  const supported = typeof navigator !== "undefined" && "serviceWorker" in navigator && "PushManager" in window;
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!supported) return null;

  const enable = async () => {
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") { toast.error("Permesso notifiche negato dal dispositivo"); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get("/push/vapid_public_key");
      if (!data.key) { toast.error("Notifiche push non disponibili"); return; }
      const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8(data.key) });
      await api.post("/push/client_subscribe", { email, order_code: orderCode, subscription: sub.toJSON() });
      setDone(true);
      toast.success("Notifiche attivate! Ti avviseremo ad ogni avanzamento del tuo ordine.");
    } catch (e) {
      toast.error("Impossibile attivare le notifiche push");
    } finally { setBusy(false); }
  };

  return (
    <button
      data-testid="client-push-btn"
      onClick={enable}
      disabled={busy || done}
      className={`mt-4 inline-flex items-center gap-2 h-11 px-5 rounded-sm font-semibold transition-colors duration-200 border ${
        done ? "border-neon-green/50 text-neon-green bg-neon-green/10 cursor-default" : "border-neon-cyan/50 text-neon-cyan hover:bg-neon-cyan hover:text-black"
      }`}
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />}
      {done ? "Notifiche attive" : "Attiva notifiche push per questo ordine"}
    </button>
  );
}
